import {
    SOCIALS_GET,
    BS_SOCIALS_GET,
    SOCIAL_CREATE,
    SOCIAL_EDIT,
    SOCIAL_DELETE,
} from './actions/social.type.js'
import {
    SET_SOCIAL,
    SET_SOCIALS,
    SET_BS_SOCIALS,
    SOCIAL_RESET,
    SET_SOCIAL_HINT, SET_SOCIAL_EDIT
} from './mutations/social.type.js'

import {CHANGE_PROGRESS} from './mutations/mutations.type.js'
import {SocialService} from "@/common/api/social.service";


const initialState = () => {
    return {
        social: {
            id: 0,
            desc: "",
            hintText: "",
        },
        edit: false,
        bs_socials: [],
        socials: [],
        socialsEdit: []
    }
}

export const state = initialState()

const getters = {
    social: state => {
        return state.social
    },
    bs_socials: state => {
        return state.bs_socials
    },
    socials: state => {
        if (state.edit) {
            return state.socialsEdit
        }

        let diff = [...state.socialsEdit]
        let c = 0
        for (let i = 0; i < state.socialsEdit.length; i++) {
            for (let j = 0; j < state.bs_socials.length; j++) {
                if (state.socialsEdit[i].id === state.bs_socials[j].socialID) {
                    diff.splice(i - c, 1)
                    c++
                    continue
                }
            }
        }
        return diff
    },
    socialsOk: (state) => {
        if (state.bs_socials == null) {
            return false
        }
        return !(state.bs_socials.length == state.socialsEdit.length)
    }
}

export const mutations = {
    [SET_SOCIAL](state, data) {
        state.social = data
    },
    [SET_SOCIAL_HINT](state, id) {
        let sc = state.socialsEdit.find(element => element.id === id)
        if (typeof sc !== "undefined") {
            state.social.hintText = sc.hintText
        }
    },
    [SET_SOCIALS](state, data) {
        state.socialsEdit = data
    },
    [SET_BS_SOCIALS](state, data) {
        state.bs_socials = data
    },
    [SET_SOCIAL_EDIT](state, data) {
        state.edit = data
    },
    [SOCIAL_RESET](state) {
        Object.assign(state.service, initialState())
    },
}

export const actions = {
    async [SOCIALS_GET]({commit}) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await SocialService.list()
        commit(SET_SOCIALS, data)
        commit(CHANGE_PROGRESS, false)
    },
    async [BS_SOCIALS_GET]({commit}) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await SocialService.get()
        commit(SET_BS_SOCIALS, data)
        commit(CHANGE_PROGRESS, false)
    },

    // eslint-disable-next-line no-unused-vars
    [SOCIAL_CREATE]({state}, data) {
        return SocialService.create(data)
    },
    // eslint-disable-next-line no-unused-vars
    [SOCIAL_EDIT]({state}, data) {
        return SocialService.update("", data)
    },
    // eslint-disable-next-line no-unused-vars
    [SOCIAL_DELETE]({state}, data) {
        return SocialService.delete(data)
    },

}
export default {
    state,
    actions,
    mutations,
    getters
}
